import React, { useEffect, useState } from 'react'
import Input from 'Components/Input'
import Multiple from 'Components/Multiple'
import Constants from 'EurestoFonction/Constants'
import Grid from '@material-ui/core/Grid'
import Data from 'EurestoClass/Data'
import Utils from 'EurestoFonction/Utils'

export default React.memo(props => {

  const [object, setObject] = useState(props.object || {})
  const [key, setKey] = useState(Utils.getRandomNumber())
  const [disabled, setDisabled] = useState(props.disabled || false)

  const onChange = (data, name) => {
    const obj = {
      ...(object || {}),
      [name]: data
    }
    setObject(obj)
    props.onChange && props.onChange(EurestoClone(obj))
  }

  useEffect(() => {
    if (!_.isEqual(props.object, object)) {
      setKey(Utils.getRandomNumber())
      setObject(props.object || {})
    }
  }, [props.object])

  return (
    <Grid key={key} container style={{ margin: 0, padding: 0 }} spacing={0} direction="column"
      justify="flex-start"
      alignItems="stretch">
      <Input
        autoFocus={!disabled}
        title={EurestoI18n.t('commun:Nom')}
        onChange={onChange}
        name={'nom'}
        disabled={disabled}
        value={object.nom || object.libelle}
      />
      <Input
        autoFocus={!disabled}
        title={EurestoI18n.t('commun:Email')}
        onChange={onChange}
        name={'email'}
        disabled={disabled}
        value={object.email || object.email}
      />
      <Multiple
        disabled={disabled}
        title={'Utilisateurs'}
        onChange={onChange}
        name={'utilisateurs'}
        value={object.utilisateurs || []}
        options={Data.list(Constants.module.CONFIGURATION, Constants.donnee.utilisateur, { archive_id: null }).map(u => ({
          value: u.id,
          label: u.libelle
        }))} />
    </Grid>
  )
})



// WEBPACK FOOTER //
// ./app/App/Module/Configuration/Component/Etablissement/Regroupement/form.js